<template>
    <div class="instances-detail">
        <SideLeftTree  v-if="!isShowNewMode" @changeLeftTree="changeLeftTree"/>
        <el-card class="box-card instances-desc" style="overflow: initial;" shadow="never">
            <div class="instances-head">
                <div>
                  <!-- <el-tooltip :content="isCollapse?'收起左侧列表':'展开左侧列表'" placement="top">
                    <el-switch
                        v-model="isCollapse"
                        @change="changeLeftTree"
                        >
                    </el-switch>
                  </el-tooltip> -->
                  <span>[<font color='green'>{{instances.name}}</font>]</span> -- <span>来自流程模板【<font color='blue'>{{instances.templateName?instances.templateName:instances.processServiceName}}(v{{instances.processDefinitionVersion}})</font>】</span></div>
                <div class="text-desc desc-content2">
                    <span>发起人：{{instances.startedBy.trueName}}</span>
                    <span>开始时间：{{instances.started}}</span>
                    <span>负责人：{{selectedUser.selectedUserNames}}</span>
                    <el-button size="mini"  title='编辑流程负责人' circle icon="el-icon-setting" @click="handelProcessAssigneeUser"></el-button>
                    <el-button size="mini" v-if="copyUserConfig"  title='设置流程抄送人' circle icon="el-icon-s-check" @click="handelProcessCopyUser"></el-button>
                </div>
                <div v-if="instances.hasOwnProperty('relationProcessInstanceId')" class="text-desc desc-content2">
                    <span >上级流程：<font style='color: #409eff;'>{{instances.relationProcessInstanceName}}</font> -> 所属任务：<font style='color: #67c23a'>{{instances.relationTaskInstanceName}}</font></span>
                </div>
                 <!-- <el-button type="success" plain icon="el-icon-info" @click.stop="handleViewComment">评论</el-button> -->
                 <!-- <el-button type="primary" plain icon="el-icon-upload"  @click="dataImport()">文件上传</el-button> -->
            </div>
            <div class="instances-btns">
                <el-button size="mini" v-if="isSwichMode" circle icon="el-icon-s-operation" title='列表模式' @click="handleModeSwich"></el-button>
                <el-button size="mini" v-if="instances.hasReports" title='业务树关系图' circle icon="el-icon-connection" @click="handelShowReportRelateTree"></el-button>
                <el-button size="mini" v-if="instances.hasSubProcess==='1'" title='主子流程关系图' circle icon="el-icon-s-grid" @click="handelShowProcessRelate"></el-button>
                <el-button size="mini" v-if="instances.canViewFormsData || showViewFormsData"  title='任务表单库' circle icon="el-icon-goods" @click="handelShowForms"></el-button>
                <el-button size="mini" v-if="instances.canViewDiagram"  title='流程图' circle icon="el-icon-picture-outline" @click="handelShowDiagram"></el-button>
                <el-button size="mini" v-if="instances.canViewFormsData && isShowSaveBtn" type="primary" title='保存数据' plain icon="el-icon-edit" @click="handelSaveForms">保存数据</el-button>
                <el-button size="mini" v-if="instances.canCancelProcess"  type="danger" title='删除流程' plain icon="el-icon-delete" @click="handleCancelProcessInstances">删除流程</el-button>
                <el-button size="mini" v-if="instances.canCancelProcess && instances.processInstanceStatus !== 4"  type="warning" title='终止流程' plain icon="el-icon-remove" @click="handleTerminalProcessInstances">终止流程</el-button>
                <el-button size="mini" v-if="instances.canCancelProcess && instances.processInstanceStatus !== 4"  type="success" title='提前完成' plain icon="el-icon-finished" @click="handleFininshedProcessInstances">提前完成</el-button>
                <el-button size="mini" v-if="instances.canCancelProcess"  type="danger" title='跳转到下一个任务节点' plain icon="el-icon-orange" @click="jumpTaskProcessInstances">跳转节点</el-button>
                <template v-if="instances.canCancelProcess && instances.processInstanceStatus !== 4" >
                  <el-button size="mini" v-if="instances.isSuspended" type="primary" title='重启流程' plain icon="el-icon-video-play" @click="handleActiviteProcessInstance">重启流程</el-button>
                  <el-button size="mini" v-else type="info" title='暂停流程' plain icon="el-icon-video-pause" @click="handleSuspendProcessInstance">暂停流程</el-button>
                </template>
              </div>
        </el-card>

        <div class="instances-content">
             <el-tabs style="width: 99%;height:99%;overflow: auto;" :tab-position="tabPosition" v-model="tabName" @tab-click="handleTabClick" type="border-card">
                  <!-- 流程记录 -->
                  <el-tab-pane class="content-instanceRecord" name="first" label="流程记录">
                    <el-card class="box-card" shadow="never">
                      <div slot="header" class="clearfix">
                          <span style="font-size:20px; font-weight:500; color:#ff9800">流程执行记录</span>
                          <el-tooltip content="按流程记录的发生时间进行排序。降序:从现在到开始; 升序:从开始到现在" placement="top">
                            <el-switch
                              style="margin-left:20px;"
                              v-model="orderBy"
                              active-text="升序"
                              inactive-text="降序"
                              @change="changeSwitch"
                            >
                          </el-switch>
                         </el-tooltip>

                         <el-button v-if="instances.canInterveneProcess"  style="float: right;margin-left:5px" type="primary" size="mini" icon="el-icon-warning" title="流程任务干预" circle @click="handelProcessDetail()"></el-button>
                         <el-button v-if="instances.canChangeTemplate"  style="float: right;" type="primary" size="mini" icon="el-icon-setting" title="流程模板变更" circle @click="handelProcessTemplate()"></el-button>
                      </div>
                        <el-row>
                            <el-col :span="16">
                                <div class="record-list">
                                    <div v-for="(record) in recordList" :key="record.id" class="record-item">
                                        <div class="record-content1" >
                                            <el-tooltip class="item" effect="dark" placement="bottom-start">
                                            <div slot="content" >{{record.recordName}}</div>
                                            <span class="record-icon"><i :class="_getIconClass(record.recordType)"></i></span>
                                            </el-tooltip>
                                            <span :style="record.recordType === 1?(record.taskState===1?'cursor:pointer;color:#4CAF50':'cursor:pointer;color:#03a9f4'):'font-weight:500'" @click="handleNavTask(record)">{{record.taskName?record.taskName:record.recordName}}</span>
                                            <span v-if="record.recordType === 4"><el-button style="float: right;" size="mini" icon="el-icon-view" title="查看子流程图" circle @click="handelViewSubprocess(record.subProcessInstanceId)"></el-button></span>
                                        </div>
                                        <div class="record-content4">
                                            <div class="record-icon record-line"><span>&nbsp;</span></div>
                                            <!-- <div class="record-icon record-line"><span v-if="record.recordType !== 0">&nbsp;</span></div> -->
                                            <div style="width:55%">
                                                <div class="record-content3">节点活动于{{record.recordTime}}开始</div>
                                                <el-tooltip slot="reference" :content="record.transferContent" effect="light" placement="top">
                                                    <div class="record-content5">{{record.transferContent}}</div>
                                                </el-tooltip>
                                                <div class="record-content2">{{record.recordContent}}</div>
                                                <el-tooltip v-if="record.hasOwnProperty('approvalInstanceId') && instances.approvalInstanceId !==''" slot="reference" :content="record.transferContent" effect="light" placement="top">
                                                    <div class="record-content5 approvalStatus" style="font-size: 13px;">
                                                        <span class ="record-content3">审批流状态：</span>
                                                        <span :class="activeClass(record)" style="cursor: pointer;" @click="handleApprovalDetail(record)">{{record.approvalStatusLabel}}</span>
                                                    </div>
                                                </el-tooltip>
                                            </div>
                                            <div style="width:20%">
                                                <div v-if="record.recordType===1" class="record-content2">
                                                <b style="color: #adadad;">节点状态:</b>
                                                <template v-if="record.taskState===1" :content="record.operateOpinion" effect="light" placement="top">
                                                    <!-- <span v-if="record.operateType===1"><el-tag >完成</el-tag></span>
                                                    <span v-if="record.operateType===2"><el-tag >同意</el-tag></span>
                                                    <span v-if="record.operateType===3"><el-tag type="danger">驳回</el-tag></span> -->
                                                    <span v-if="record.operateType===0 || record.operateType===1 || record.operateType===2 "><el-tag type="success">{{record.taskStateName}}</el-tag></span>
                                                    <span v-if="record.operateType===3 || record.operateType===9 "><el-tag type="danger">{{record.taskStateName}}</el-tag></span>
                                                    <span v-if="record.operateType===6 || record.operateType===7|| record.operateType===8 "><el-tag type="info">{{record.taskStateName}}</el-tag></span>
                                                    <span v-if="record.operateType===-1"><el-tag type="danger">{{record.taskStateName}}</el-tag></span>
                                                </template>
                                                <template v-else content="进行中" effect="light" placement="top">
                                                    <el-tag type="primary">进行中</el-tag>
                                                </template>
                                                </div>
                                            </div>
                                            <div style="width:40%">
                                                <div v-if="record.operateType>1 || record.operateOpinion" class="record-content2">
                                                <el-tooltip :content="record.operateOpinion" effect="light" placement="top">
                                                    <div><b style="color: #ef0812;">审批意见:</b> <span class="record-content1 record-opinion">{{record.operateOpinion}}</span></div>
                                                </el-tooltip>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                 <div class="processTreeHead">主子流程列表：</div>
                                 <el-table
                                    :data="complateProcessRelateList"
                                    height="380"
                                    row-key="id"
                                    default-expand-all
                                    style="width: 95%;overflow: auto;"
                                    :tree-props="{children: 'children'}"
                                    :border="true"
                                    v-loading="complateLoading">
                                    <el-table-column prop="label" label="流程名称" :show-overflow-tooltip="true"></el-table-column>
                                    <el-table-column prop="assigneeUserName" label="负责人" :show-overflow-tooltip="true" width="75"></el-table-column>
                                </el-table>
                            </el-col>
                        </el-row>
                      </el-card>
                  </el-tab-pane>
                <!-- 项目管理 -->
                 <el-tab-pane v-if="instances.hasOwnProperty('timeTemplateId') && instances.timeTemplateId !==''" name="seventh" label="项目管理">
                        <TimeConfigDetail v-if="isShowTimeConfigDetail"
                          :key="loadTimer"
                          ref="timeConfigDetail"
                          :isInstance="true"
                          :instancesInfo="instances"
                          :tableHeight="400"
                          :ifConfigTask="ifConfigTask || ifConfigProcess"
                          :isFullScreen="isFullScreenForTime"
                          @handleFullScreenForTime="handleFullScreenForTime"
                          @initTimeConig="initTimeConig" />
                  </el-tab-pane>
                 <!-- 闭环管理 -->
                 <el-tab-pane v-if="instances.hasOwnProperty('closeTemplateId') && instances.closeTemplateId !==''" name="ninth" label="闭环管理">
                        <CloseTemplateDetail
                          v-if="isShowCloseConfigDetail"
                          ref="closeTemplateDetailRef"
                          :key="loadTimer"
                          :isInstance="true"
                          :ifConfig="ifConfigTask || ifConfigProcess"
                          :tableHeight="340"
                          :instancesInfo="instances"
                          />

                  </el-tab-pane>
                  <!-- 流程表单 -->
                  <el-tab-pane v-if="instances.hasOwnProperty('formObj') && instances.formObj.structure.length>0" class="process-detail-Forms" name="fifth" label="流程表单">
                      <el-collapse style="height:430px;overflow-y:auto;" v-if="isShowForm" v-model="collapseActiveName" accordion>
                          <el-collapse-item v-for="(form, index) in forms" :key="form.id" :title="form.formName" :name="form.id">
                              <template slot="title">
                                  <div class='el-collapse-title'>
                                     <!-- <span>{{form.formName}}<el-button style=" margin-left: 20px; " size="mini" icon="el-icon-printer" @click.stop="handleFormFullScreen(index)">全屏</el-button></span> -->
                                     <span>【{{form.formName}}】</span>
                                          <!-- <el-button size="mini" icon="el-icon-printer" @click.stop="handleFormFullScreen(index)">全屏</el-button> -->
                                        <el-button size="mini" icon="el-icon-printer" @click.stop="handlePrint(index)">打印</el-button>
                                  </div>
                                  <el-button style="margin-right: 10px" size="mini" icon="el-icon-rank" @click.stop="handleProcessFormFullScreen(formData[index],form)">全屏</el-button>
                              </template>
                              <el-form :model="formData[index].values" :key="loadTimerField"  :ref="'customForm'+index" label-width="165px" :id="`print${form.id}`">
                                  <FieldItem
                                        v-for="(field,index2) in form.fieldsList"
                                        :findex="index2"
                                        :formIndex="index"
                                        :ref="'fieldItemChild'+index2"
                                        :formId="form.id"
                                        :formConfig="form"
                                        :key="field.fieldId"
                                        :field="field"
                                        :formData="formData[index].values"
                                        :colSpan="form.colSpan"
                                        :processInstance="instances"
                                        :fieldsList="form.fieldsList"
                                        @loadLinkData="loadLinkData"
                                        @refreshViewField="refreshViewField"
                                        @asynMainFormData="asynMainFormData"
                                        v-if="!field.formFieldAuth||field.formFieldAuth=='1'"
                                   />
                              </el-form>
                          </el-collapse-item>
                      </el-collapse>
                  </el-tab-pane>
                  <!-- 文件列表 -->
                  <el-tab-pane  v-if="instances.hasOwnProperty('isShowFileList') && instances.isShowFileList" name="second" label="文件列表">
                      <ArchiveFilesList v-if="isShowMyFile" ref="processFiles" :key="loadTimerFile" bizType="process" :processInstanceId="this.instances.id" :templateId="instances.archiveTemplateId" :isSubProcess="isSubProcess" :isCloseFileUpload="instances.isCloseFileUpload"/>
                  </el-tab-pane>
                  <!-- 档案管理 -->
                  <!-- <el-tab-pane v-if="instances.hasOwnProperty('archiveTemplateId') && instances.archiveTemplateId !=='' " name="four" label="档案管理">
                     <ArchiveTable
                          style="width:100%"
                          v-if="isShowArchiveTable"
                          ref="archiveTable"
                          :isInstance="true"
                          :isShowBtn="true"
                          :isApply="true"
                          :templateId="instances.archiveTemplateId"
                          :processInstanceId="instances.id"
                          :instancesInfo="instances"
                          :rootPath="rootPath"
                          :isFullScreen="isFullScreen"
                          @handleFullScreen="handleFullScreen"
                      />
                  </el-tab-pane> -->
                   <!-- 沟通列表 -->
                  <el-tab-pane v-if="instances.hasOwnProperty('isShowComment') && instances.isShowComment" name="third" label="沟通留言">
                      <Comment
                       v-if="isShowMyComment"
                        class="comments"
                        :list="commentList"
                        :isMsgToUsers="true"
                        @commentAdd="handleCommentAdd"
                        @commentDelete="handleCommentDelete"
                        @commentSend="chooseCommentUser"
                      />
                  </el-tab-pane>
                  <!-- 审批流列表 -->
                  <el-tab-pane  v-if="instances.hasOwnProperty('isShowApproveList') && instances.isShowApproveList" name="sixth" label="审批流列表">
                      <MyApproval
                            ref="myApproval"
                             v-if="isShowMyApproval"
                             :key="loadTimer"
                            :busiProcessInstanceId="this.instances.id"
                            :busiProcessInstanceName="this.instances.name"
                            :belongProcessFlag="1"
                            :isFullScreen="isFullScreenForApproval"
                            :isRead="isRead"
                            :processIsRead="processIsRead"
                            @handleFullScreenForApproval="handleFullScreenForApproval" />
                  </el-tab-pane>

                 <!-- 流程动态 -->
                 <el-tab-pane v-if="instances.hasOwnProperty('isShowProcessAdj') && instances.isShowProcessAdj" name="eighth" label="流程动态">
                     <ProcessAdjList ref="processAdjList" :processInstanceId="currentProcessInstanceId" />
                  </el-tab-pane>
              </el-tabs>
        </div>

         <el-dialog
            title="档案管理"
             append-to-body
            :fullscreen="true"
            :visible.sync="isShowArchiveTemplate"
            >
            <ArchiveTemplate
                v-if="isShowArchiveTemplate"
                ref="archiveTemplate"
                :isInstance="true"
                :templateId="instances.archiveTemplateId"
                :processInstanceId="instances.id"
                :instancesInfo="instances"
                :rootPath="rootPath"
            />
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowArchiveTemplate=false">取 消</el-button>
            </span>
        </el-dialog>
         <el-dialog
            title="档案管理"
            :fullscreen="true"
            append-to-body
            :visible.sync="isShowFullArchiveTable"
             @close="hideDialog"
            >
            <ArchiveTable
                v-if="isShowFullArchiveTable"
                ref="archiveTable"
                :isInstance="true"
                :isShowBtn="true"
                :isApply="true"
                :templateId="instances.archiveTemplateId"
                :processInstanceId="instances.id"
                :instancesInfo="instances"
                :rootPath="rootPath"
                :isFullScreen="isFullScreen"
                :tbHeight="'462'"
            />
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowFullArchiveTable=false">取 消</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="文件上传"
            :visible.sync="isShowUpload">
            <ProcessFiles ref="fileInstance"  bizType="process" :processInstanceId="this.instances.id" @importComplete="handleFileSearch" />
        </el-dialog>
        <!-- 显示图标 -->
        <el-dialog
            title="流程图"
            width="80%"
            append-to-body
            :fullscreen=true
            :visible.sync="isShowDiagram"
            custom-class="diagram-dialog">
            <ProcessDiagram
              ref="diagrams"
              :processInstance="instances"
              :taskList="taskList"
              :archiveTemplateTreeList="archiveTemplateTreeList"
              @refreshProcessList="handelProcessDetail"
            />
        </el-dialog>

          <!-- 显示图标 -->
        <el-dialog
            title="子流程图"
            width="80%"
            append-to-body
            :fullscreen=true
            :visible.sync="isShowSubDiagram"
            custom-class="diagram-dialog">
            <ProcessDiagram
              ref="subDiagrams"
              :processInstance="subInstances"
              :taskList="subTaskList"
              :archiveTemplateTreeList="subArchiveTemplateTreeList"
            />
        </el-dialog>

         <el-dialog
            title="任务表单库"
            top="1vh"
            width="80%"
            append-to-body
            :fullscreen=true
            :visible.sync="isShowForms">
            <ProcessForms
                :processInfo="processInfo"
            />
            <span slot="footer" class="dialog-footer">
                <el-button @click="handelHideForms">取 消</el-button>
            </span>
        </el-dialog>

        <el-dialog
            title="流程任务干预"
            width="80%"
            append-to-body
            :fullscreen=true
            :visible.sync="isShowSetting"
            @close="closeProcessSetting"
            >
            <ProcessSetting
                :key="loadTimer"
              :processInstance="instances"
              :taskList="taskList"
              :batchTaskAssigneeUserChange="true"
              :archiveTemplateTreeList="archiveTemplateTreeList"
              @refreshProcessList="handelProcessDetail"
            />
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelProcessSetting">取 消</el-button>
                <!-- <el-button type="primary" @click="saveProcessSetting">保存配置</el-button> -->
            </span>
        </el-dialog>


        <!-- <Sidebox class="sideboxcls" v-model="active">
            <Comment
                class="comments"
                :list="commentList"
                @commentAdd="handleCommentAdd"
                @commentDelete="handleCommentDelete"
            />
        </Sidebox> -->

         <el-dialog
              title="流程模板变更"
              width="60%"
              top="1vh"
              append-to-body
              custom-class="processTemplateChange"
              :visible.sync="isShowTemplateDesc"
              >
              <TemplatePop ref="templatePop" :isIntervene="true" :templateInfo="templateInfo"/>
              <span slot="footer" class="dialog-footer">
                  <el-button @click="isShowTemplateDesc=false">取 消</el-button>
                  <el-button type="primary" @click="handleEditTemplateInfo">确 定</el-button>
              </span>
          </el-dialog>

           <el-dialog
                title="审批流列表"
                 append-to-body
                :fullscreen="true"
                :visible.sync="isShowFullScreenForApproval"
                @close="hideFullScreenDialogForApproval">
                <MyApproval
                    ref="myApprovalFullCreen"
                    :key="loadTimer"
                    v-if="isShowFullScreenForApproval"
                    :busiProcessInstanceId="this.instances.id"
                    :busiProcessInstanceName="this.instances.name"
                    :belongProcessFlag="1"
                    :isRead="isRead"
                    :processIsRead="processIsRead"
                    :isFullScreen="isFullScreenForApproval" />
                <span slot="footer" class="dialog-footer">
                    <el-button @click="isShowFullScreenForApproval=false">取 消</el-button>
                </span>
            </el-dialog>

            <el-dialog
                title="项目管理列表"
                 append-to-body
                :fullscreen="true"
                :visible.sync="isShowFullScreenForTime"
                @close="hideFullScreenDialogForTime">
                    <TimeConfigDetail v-if="isShowTimeConfigDetail"
                          ref="timeConfigDetail"
                          :isInstance="true"
                          :instancesInfo="instances"
                          :tableHeight="460"
                          :ifConfigTask="ifConfigTask || ifConfigProcess"
                          :isFullScreen="isFullScreenForTime"
                          @initTimeConig="initTimeConig"
                          />
                   <span slot="footer" class="dialog-footer">
                  <el-button @click="isShowFullScreenForTime=false">取 消</el-button>
                </span>
            </el-dialog>
            <el-dialog
                title="打印确认页"
                append-to-body
                top="4vh"
                :fullscreen=true
                :visible.sync="isShowPrintUtil">
                <PrintUtil :key="loadTimer" ref="printUtil" :formInfo="printForm"  />
            </el-dialog>
        <iframe :src="fileDownloadUrl" width="0" height="0" frameborder="0" />

         <el-dialog
              class="popEditModelDetail"
              :fullscreen=true
              :visible.sync="isShowModelDetail"
              append-to-body
              >
                <ModelDetail
                  :key="processLoadTimer"
                  ref="modelDetailChild"
                  :isShowForm="isShowFormDetail"
                  :formInfo="formInfo"
                  @modelComplete="handleModelComplete"
                  @setIsShowForm="setIsShowForm"
            />
          </el-dialog>

        <el-dialog custom-class="user-org-dialog"
            title="选择负责人"
            top="4vh"
            width="75%"
            :visible.sync="isShowUserOrg"
            append-to-body>
            <UserOrg ref="userOrg" :key="loadTimer" :multiple="false" :selectedUser="selectedUser" />
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowUserOrg = false">取 消</el-button>
                <el-button type="primary" @click="confirmClick">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog custom-class="user-org-dialog"
            title="选择抄送人"
            top="4vh"
            width="75%"
            :visible.sync="isShowCopyUserOrg"
            append-to-body>
            <UserOrg ref="copyUserOrg" :key="loadTimer" :multiple="true" :selectedUser="selectedCopyUser" />
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowCopyUserOrg = false">取 消</el-button>
                <el-button type="primary" @click="confirmCopyUserClick">确 定</el-button>
            </span>
        </el-dialog>
         <el-dialog
            title="任务详情"
            :fullscreen="true"
            append-to-body
            v-if="isShowTaskDetail"
            :visible.sync="isShowTaskDetail"
            >
             <div style="margin-top: -20px;">
                <TaskDetail
                  class="popDetailTaskClass"
                  ref="taskDetailRef"
                  :taskInfo="taskInfo"
                  :isRead="true"
                />
             </div>
        </el-dialog>
         <el-dialog
            title="流程详情"
            :fullscreen=true
            :visible.sync="isShowProcessDetail"
            append-to-body
            >
            <ProcessDetail :key="loadTimer" :instances="instancesInfo"/>
        </el-dialog>
        <el-dialog
            title="主子流程关系图"
            :fullscreen=true
            :visible.sync="isShowProcessRelate"
            append-to-body
            >
            <ProcessRelateTree :key="loadTimer" ref="processRelateTree" :processInstanceId ="instances.id" />
        </el-dialog>
         <el-dialog
            title="业务树关系图"
            custom-class="process-report-dialog"
            class="process-report-tree"
            :fullscreen=true
            :visible.sync="isShowReportRelateTree"
            append-to-body
            >
            <ProcessReportList :key="loadTimer" ref="reportRelateTree" :reports ="instances.reports" />
        </el-dialog>
        <el-dialog
            title="选择待发送人员"
            top="4vh"
            width="75%"
            :visible.sync="isShowCommentUserOrg"
            append-to-body
          >
          <UserOrg ref="userOrgExtComment" :multiple="true" :selectedUser="selectedCommentUser" :canDrop="true"/>
          <span slot="footer" class="dialog-footer">
              <el-button @click="isShowCommentUserOrg = false">取 消</el-button>
              <el-button type="primary" @click="confirmCommontClick">确定发送</el-button>
          </span>
        </el-dialog>
        <el-dialog
            title="审批流进度"
            top="4vh"
            width="75%"
            :visible.sync="isShowDynamicApprovalPop"
            append-to-body
          >
            <DynamicApprovalPop
                :isStatus="true"
                :approvalDetail="approvalDetail"
                :cellValue="1"
            />
        </el-dialog>
    </div>
</template>

<script>
    import DynamicApprovalPop from '@/components/DynamicTable/DynamicApprovalPop';
    import UserOrg from '@/components/UserOrg';
    import Comment from '../components/Comment';
    import ProcessDiagram from './ProcessDiagram';
    import ProcessForms from './ProcessForms';
    import ProcessSetting from './ProcessSetting';
    import ArchiveFilesList from '../components/ArchiveFilesTabs/ArchiveFilesList';
    import ProcessFiles from '../components/ProcessFiles';
    import ArchiveTemplate from '@/components/ArchiveTemplate';
    import ArchiveTable from '@/components/ArchiveTable';
    import ModelDetail from '@/pages/business/BusinessApplication/ModelDetail';
    import TemplatePop from '@/pages/process/ProcessTemplate/TemplatePop';
    import TimeConfigDetail from '@/pages/process/TimeConfig/TimeConfigDetail';
    import CloseTemplateDetail from '@/pages/process/CloseTemplate/CloseTemplateDetail/CloseTemplateDetail';
    import MyApproval from '@/pages/process/MyApproval';
    import mixinsNav from '@/mixins/mixins-nav';
    import PrintUtil from '@/components/PrintUtil';
    import ProcessAdjList from '@/components/ProcessAdjList';
    import ProcessRelateTree from '@/components/ProcessRelateTree';
    import ProcessReportList from './ProcessReportList';
    import { isEmpty } from 'lodash';
    import { getGlobalConf } from '@/utils/grocer';
    import { API_FILE_DOWNLOAD } from '@/common/constants';
    import TaskDetail from '@/pages/process/MyTask/TaskDetail';
    import SideLeftTree from '@/components/SideLeftTree';
    import { terminalProcessInstance, activiteProcessInstance, suspendProcessInstance, getApprovalInstanceDetail, getComplateProcessTree, getProcessInstanceCopyUserList, saveProcessInstanceCopyUsers, getProcessTaskDetail, updProcessAssigneeUser, getProcessInstanceCloseTemplate, saveProcessInstance, getArchiveTemplateTreeList, getProcessInstanceTemplate, getProcessInstancesRecordList, getProcessInstanceFiles, deleteProcessInstance, cancelProcessInstance, getProcessInstancesCommentList, saveProcessInstancesComment, delProcessFile, delTaskFile, deleteProcessInstancesComment, getAllUserTask, getProcessInstancesDetail, saveProcessInstanceTemplate, sendApprovalCommentMsg, downloadFiles, jumpTaskProcessInstances} from '@/data-model';
    export default {
        mixins: [ mixinsNav ],
        components: {
            DynamicApprovalPop,
            ProcessReportList,
            ProcessDiagram,
            Comment,
            ProcessForms,
            ArchiveFilesList,
            ProcessFiles,
            ProcessSetting,
            ArchiveTemplate,
            ArchiveTable,
            ModelDetail,
            TemplatePop,
            MyApproval,
            TimeConfigDetail,
            PrintUtil,
            ProcessAdjList,
            CloseTemplateDetail,
            UserOrg,
            TaskDetail,
            ProcessRelateTree,
            SideLeftTree
        },
        data () {
            return {
                isShowDynamicApprovalPop: false,
                complateLoading: false,
                complateProcessRelateList: [], // 主子流程list
                copyUserConfig: false,
                currentUserInfo: {}, // 当前登录人信息
                isShowReportRelateTree: false,
                isShowProcessRelate: false,
                isSubProcess: false,
                isShowCopyUserOrg: false,
                selectedCopyUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                isShowUserOrg: false,
                selectedUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                isCollapse: true,
                printForm: {},
                processLoadTimer: '',
                isShowFormDetail: false,
                loadTimerFile: '',
                loadTimer: '',
                loadTimerField: '',
                isShowPrintUtil: false,
                ifConfigTask: false,
                isShowMyApproval: false,
                isShowMyComment: false,
                isShowMyFile: false,
                oldProcessInstanceName: '',
                isShowTimeConfigDetail: false,
                isShowForm: false,
                formInfo: {},
                isShowModelDetail: false,
                collapseActiveName: '',
                formData: [],
                isShowSaveBtn: false,
                orderBy: false, // 流程执行记录按时间排序 0现在到开始 1从开始到现在
                tabName: 'first',
                tabPosition: 'top',
                filePage: {
                    currentPage: 1, // 当前页码
                    pageSize: 10, // 每页条数
                    totalPageNum: 1 // 总页数
                },
                filesList: [],
                fileDownloadUrl: '',
                isShowUpload: false,
                isShowDiagram: false,
                isShowForms: false,
                isShowSetting: false,
                recordList: [],
                commentList: [],
                processInfo: {},
                active: false, // 是否显示侧滑弹窗
                searchFileParams: {
                    fileName: '',
                    processInstanceId: '',
                    currentPage: 1, // 当前页码
                    pageSize: 10 // 每页条数
                },
                taskList: [],
                archiveTemplateTreeList: [],
                isShowArchiveTemplate: false,
                isShowArchiveTable: false,
                isShowFullArchiveTable: false,
                isFullScreen: false,
                isShowFullScreenForApproval: false,
                isFullScreenForApproval: false,
                isShowFullScreenForTime: false,
                isFullScreenForTime: false,
                rootPath: '/process/myProcess/:processInstanceId',
                subInstances: {},
                isShowSubDiagram: false,
                subTaskList: [],
                subArchiveTemplateTreeList: [],
                selectFormIndex: 0,
                templateInfo: {
                    processInstanceId: '',
                    processInstanceName: '',
                    processServiceName: '',
                    processServiceId: '',
                    deploymentId: '',
                    id: '',
                    templateName: '',
                    templateDesc: '',
                    archiveTemplateId: '', // 档案模板
                    archiveTemplateName: '',
                    timeTemplateId: '',
                    timeTemplateName: '',
                    closeTemplateId: '',
                    closeTemplateName: '',
                    processServiceType: '',
                    dataOperate: {
                        dataSource: 2,
                        forms: []
                    },
                    parentProcessInstanceId: '',
                    parentProcessInstanceName: '',
                    reports: []
                },
                isShowTemplateDesc: false,
                isReloadProcess: false,
                currentProcessInstanceId: '',
                isShowCloseConfigDetail: false,
                isShowTaskDetail: false,
                taskInfo: {},
                urlPath: getGlobalConf().routerBasePath + '/process/myProcess/:processInstanceId',
                isShowProcessDetail: false,
                instancesInfo: {},
                isShowCommentUserOrg: false,
                msgComment: {},
                selectedCommentUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                processIsRead: false,
                approvalDetail: {}
            };
        },
        computed: {
            forms () {
                if (isEmpty(this.instances.formObj)) {
                    return [];
                } else {
                    return this.instances.formObj.structure;
                }
            }
        },
        props: {
            instances: {
                type: Object,
                default: () => {}
            },
            isFinish: {
                type: Boolean
            },
            isCancel: {
                type: Boolean,
                default: false
            },
            showViewFormsData: {// 显示表单库
                type: Boolean,
                default: false
            },
            isRead: {
                type: Boolean,
                default: false
            },
            isSwichMode: {
                type: Boolean,
                default: false
            },
            ifConfigProcess: {// 能否对流程处理有高级权限：修改项目模板、闭环模板、点击查看任务详情，点击查看其他页签里的审批流详情等
                type: Boolean,
                default: false
            },
            isShowNewMode: {
                type: Boolean,
                default: false
            },
            isFromBusTab: {
                type: Boolean,
                default: false
            }
        },
        created () {
            // console.log(this.instances);
            // console.log(this.isShowNewMode);
            if (!isEmpty(this.instances.relationProcessInstanceId)) {
                this.isSubProcess = true;
            }
            // console.log(this.isSubProcess);
            this.selectedUser.selectedUserIds = this.instances.assigneeUserId;
            this.selectedUser.selectedUserNames = this.instances.assigneeUserName;
            this.getRecordList();
            // this.getCommentList();
            // this.handleFileSearch();
            let isShowDiagram = sessionStorage.getItem('isShowDiagram');
            if (isShowDiagram) {
                this.handelShowDiagram();
                sessionStorage.removeItem('isShowDiagram');
            };
            this._initFormData();
            let currentUserStr = sessionStorage.getItem('currentUserInfo');
            if (currentUserStr) {
                let currentUserInfo = JSON.parse(currentUserStr);
                this.currentUserInfo = currentUserInfo;
                this.ifConfigTask = currentUserInfo.userId === this.instances.startedBy.id;
                this.processIsRead = currentUserInfo.userId === this.instances.startedBy.id;
                this.instances.canInterveneProcess = this.instances.canInterveneProcess ? this.instances.canInterveneProcess : false;
                this.instances.canChangeTemplate = this.instances.canChangeTemplate ? this.instances.canChangeTemplate : false;
                // 是流程负责人，默认将模板变更和干预权限放开
                if (currentUserInfo.userId === this.instances.assigneeUserId) { // 流程负责人
                    let resources = currentUserInfo.resources;
                    if (resources) {
                        for (let i = 0; i < resources.length; i++) {
                            if (resources[i].resourceUrl === 'processTemplateChangeForMasterPeople' || resources[i].resourceUrl === 'ProcessTemplateChangeAllBtn') { // 是否拥有流程模板变更的权限
                                this.instances.canChangeTemplate = true;
                            }
                            if (resources[i].resourceUrl === 'processTaskInterveneForMasterPeople' || resources[i].resourceUrl === 'ProcessTaskInterveneAllBtn') { // 是否拥有流程干预变更的权限
                                this.instances.canInterveneProcess = true;
                            }
                        }
                    }
                    this.ifConfigTask = true;
                    this.processIsRead = true;
                } else if (currentUserInfo.userId === this.instances.startedBy.id) { // 流程发起人
                    let resources = currentUserInfo.resources;
                    if (resources) {
                        for (let i = 0; i < resources.length; i++) {
                            if (resources[i].resourceUrl === 'ProcessTemplateChangeBtn' || resources[i].resourceUrl === 'ProcessTemplateChangeAllBtn') { // 是否永远流程模板变更的权限
                                this.instances.canChangeTemplate = true;
                            }
                            if (resources[i].resourceUrl === 'ProcessTaskInterveneBtn' || resources[i].resourceUrl === 'ProcessTaskInterveneAllBtn') { // 是否永远流程干预变更的权限
                                this.instances.canInterveneProcess = true;
                            }
                        }
                    }
                    this.ifConfigTask = true;
                    this.processIsRead = true;
                } else { // 全部
                    let resources = currentUserInfo.resources;
                    if (resources) {
                        for (let i = 0; i < resources.length; i++) {
                            if (resources[i].resourceUrl === 'ProcessTemplateChangeAllBtn') { // 是否拥有所有流程模板变更的权限
                                this.instances.canChangeTemplate = true;
                            }
                            if (resources[i].resourceUrl === 'ProcessTaskInterveneAllBtn') { // 是否拥有所有流程干预变更的权限
                                this.instances.canInterveneProcess = true;
                            }
                        }
                    }
                    this.ifConfigTask = true;
                    this.processIsRead = true;
                }
                if (this.ifConfigProcess) {
                    this.processIsRead = true;
                }

                // 流程负责人和发起人默认有编辑抄送人权限
                if (currentUserInfo.userId === this.instances.assigneeUserId || currentUserInfo.userId === this.instances.startedBy.id) {
                    this.copyUserConfig = true;
                }
            }
            this.getComplateProcessTree();
            this.isReloadProcess = false;
        },
        methods: {
            _initFormData () {
                this.selectFormIndex = 0;
                // let objTemporaryData = this._getTemporaryFormData();
                let objTemporaryData = this._getTemporaryFormData();
                this.formData.length = 0;
                this.isShowForm = false;
                if (this.forms && this.forms.length > 0) {
                    this.collapseActiveName = this.forms[0].id;// 默认打开第一个表单
                }
                if (objTemporaryData && Array.isArray(objTemporaryData)) {
                    // let idx=0;
                    let formMap = new Map();
                    this.forms.forEach(element => {
                        // console.log(element.id+","+form.formId);
                        let isMatch = false;
                        objTemporaryData.forEach(form => {
                            if (element.id === form.formId) {
                                // let formData = cloneDeep(form);
                                // console.log(formData);
                                // form = this.setNewAttr(element, formData);
                                // console.log(form);
                                this.formData.push(form);
                                formMap.set(form.formId, form);
                                isMatch = true;
                            }
                        });
                        if (!isMatch) {
                            this.renderdefaultForm(element);
                        }
                    });
                } else {
                    this.forms.forEach(element => {
                        this.renderdefaultForm(element);
                    });
                }
                this.isShowForm = true;
            },
            setNewAttr (element, form) {
                let fieldsList = element.fieldsList;
                let values = {};
                let attributes = {};
                for (let index = 0, len = fieldsList.length; index < len; index++) {
                    const element = fieldsList[index];
                    if (!form.attributes.hasOwnProperty(element.id)) {
                        values[element.id] = '';
                        attributes[element.id] = element.type;
                    } else {
                        values[element.id] = form.values[element.id];
                        attributes[element.id] = form.attributes[element.id];
                    }
                }
                form.values = values;
                form.attributes = attributes;
                if (form.hasOwnProperty('modelInstanceId') && form.modelInstanceId) {
                    form.values.isOldData = true;
                }
                return form;
            },
            renderdefaultForm (element) {
                let fieldsList = element.fieldsList;
                let values = {};
                let attributes = {};
                for (let index = 0, len = fieldsList.length; index < len; index++) {
                    const element = fieldsList[index];
                    values[element.id] = '';
                    attributes[element.id] = element.type;
                    let ext2 = element.options.ext2;
                    if (ext2) {
                        let curObj = JSON.parse(ext2);
                        element.formFieldAuth = curObj.formFieldAuth;
                        element.approveFieldAuth = curObj.approveFieldAuth;
                    }
                }
                this.formData.push({
                    formId: element.id,
                    values: values,
                    attributes: attributes,
                    colSpan: element.colSpan ? element.colSpan : 1,
                    ext1: element.ext1 ? Number(element.ext1) : 0
                });
            },
            _getTemporaryFormData () {
                let temporaryFormData;
                if (this.instances.formObj && this.instances.formObj.instance) {
                    try {
                        let strTemporaryData = this.instances.formObj.instance;
                        let objTemporaryData = JSON.parse(strTemporaryData);
                        temporaryFormData = objTemporaryData;
                    } catch (error) {
                        console.error('解析暂存的任务表单数据异常：', error);
                    }
                }
                return temporaryFormData;
            },
            handelShowTable () { // 列表模式
                this.isShowArchiveTemplate = false;
                this.isShowArchiveTable = true;
                setTimeout(() => { // 默认回显值
                    this.$refs.archiveTable._initPage();
                }, 0);
            },
            handelShowDisk () { // 云盘模式
                this.isShowArchiveTemplate = true;
                this.isShowArchiveTable = false;
                setTimeout(() => { // 默认回显值
                    this.$refs.archiveTemplate._initPage();
                }, 0);
            },
            _getIconClass (recordType) {
                let strClass = 'el-icon-location';// 事件
                if (recordType === 0) {

                } else if (recordType === 1) { // 任务
                    strClass = 'el-icon-setting';
                } else if (recordType === 2) { // 网关
                    strClass = 'el-icon-share';
                } else if (recordType === 3) { // 子流程
                    strClass = 'el-icon-d-caret';
                } else if (recordType === 4) { // 嵌套子流程
                    strClass = 'el-icon-news';
                }
                return strClass;
            },
            async getComplateProcessTree () {
                this.complateLoading = true;
                try {
                    this.complateProcessRelateList = await getComplateProcessTree(this.instances.id);
                    this.complateLoading = false;
                } catch (error) {
                    console.error(error);
                    this.complateLoading = false;
                }
            },
            async getRecordList () {
                if (this.instances) {
                    const loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    this.recordList = await getProcessInstancesRecordList(this.instances.id, this.orderBy ? 1 : 0);
                    loading.close();
                    // console.log(this.recordList);
                }
            },
            async getCommentList () {
                if (this.instances) {
                    let { data } = await getProcessInstancesCommentList({
                        processInstanceId: this.instances.id
                    });
                    this.commentList = data;
                }
            },
            async handleFileSearch () {
                this.isShowUpload = false;
                if (this.instances) {
                    this.searchFileParams.processInstanceId = this.instances.id;
                    this.searchFileParams.currentPage = this.filePage.currentPage;
                    this.searchFileParams.pageSize = this.filePage.pageSize;
                    let formData = await getProcessInstanceFiles(this.searchFileParams);
                    this.filesList = formData.data;
                    this.filePage = {
                        currentPage: formData.currentPage,
                        pageSize: formData.pageSize,
                        totalPageNum: formData.totalPageNum
                    };
                }
            },
            async handleCommentAdd (comment) {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                await saveProcessInstancesComment({
                    processInstanceId: this.instances.id,
                    comments: comment.content,
                    texts: comment.text,
                    mainId: comment.mainId,
                    supId: comment.supId
                });
                await this.getCommentList();
                loading.close();
            },
            async handleCommentDelete (comment) {
                await deleteProcessInstancesComment(comment.id);
                await this.getCommentList();
            },
            async confirmCommontClick () {
                let loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$refs.userOrgExtComment.setChoosedUser();
                this.msgComment.supId = this.selectedCommentUser.selectedUserIds + ';' + this.selectedCommentUser.selectedUserNames;
                this.msgComment.mainId = this.instances.name;
                this.msgComment.isDelete = 2;// 1:审批流，2：流程，3：任务
                await sendApprovalCommentMsg(this.msgComment);
                loading.close();
                this.isShowCommentUserOrg = false;
            },
            chooseCommentUser (comment) {
                this.selectedCommentUser = {
                    selectedUserIds: '',
                    selectedUserNames: ''
                };
                this.msgComment = comment;
                setTimeout(() => { // 初始化
                    this.$refs.userOrgExtComment._initPage();
                }, 0);
                this.isShowCommentUserOrg = true;
            },
            async handleCancelProcessInstances () {
                this.$confirm(`您确定要删除流程[ ${this.instances.name} ]吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    // loading = this.$loading({
                    //     lock: true,
                    //     text: 'Loading',
                    //     spinner: 'el-icon-loading',
                    //     background: 'rgba(0, 0, 0, 0.7)'
                    // });
                    // await cancelProcessInstance(this.instances.id);
                    // loading.close();
                    // this.$emit('reloadProcess');
                    let tempLoading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    this.$confirm('删除流程时，是否同时级联删除当前流程关联对应的表单、文件及子流数据数据？请慎重选择', '提示', {
                        distinguishCancelAndClose: true,
                        confirmButtonText: '级联数据全部删除',
                        cancelButtonText: '只删除流程',
                        type: 'warning'
                    }).then(async () => {
                        await cancelProcessInstance(this.instances.id);
                        tempLoading.close();
                        this.$emit('reloadProcess');
                    }).catch(async action => {
                        if (action === 'cancel') {
                            await deleteProcessInstance(this.instances.id);
                            tempLoading.close();
                            this.$emit('reloadProcess');
                        } else {
                            tempLoading.close();
                        }
                    });
                }).catch(() => {
                });
            },
            async handleTerminalProcessInstances () {
                this.$confirm(`您确定要终止流程[ ${this.instances.name} ]吗？这会导致流程直接完成不可恢复，请谨慎处理。`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    let tempLoading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    this.$confirm('终止流程时，是否级联终止当前流程内表单数据所关联的数据也变为终止状态？', '提示', {
                        distinguishCancelAndClose: true,
                        confirmButtonText: '否',
                        cancelButtonText: '是',
                        type: 'warning'
                    }).then(async () => {
                        await terminalProcessInstance({processInstanceId: this.instances.id, isCascade: false});// 否
                        tempLoading.close();
                        this.$emit('reloadProcess');
                    }).catch(async action => {
                        if (action === 'cancel') {
                            await terminalProcessInstance({processInstanceId: this.instances.id, isCascade: true});// 是
                            tempLoading.close();
                            this.$emit('reloadProcess');
                        } else {
                            tempLoading.close();
                        }
                    });
                }).catch(() => {
                });
            },
            async handleFininshedProcessInstances () {
                this.$confirm(`当前流程还有任务未完成，您确定要提前完成流程[ ${this.instances.name} ]吗？这会导致流程直接完成，请谨慎处理。`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    let tempLoading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    await terminalProcessInstance({processInstanceId: this.instances.id, isCascade: false, isFinished: true});// 直接完成流程
                    tempLoading.close();
                    this.$emit('reloadProcess');
                }).catch(() => {
                });
            },
            async handleActiviteProcessInstance () {
                this.$confirm(`您确定要重启当前流程[ ${this.instances.name} ]吗？这会重新恢复流程正在进行的任务可以正常执行。`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    let tempLoading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    await activiteProcessInstance(this.instances.id);// 重启流程
                    tempLoading.close();
                    this.$emit('reloadProcess');
                }).catch(() => {
                });
            },
            async handleSuspendProcessInstance () {
                this.$confirm(`您确定要暂停当前流程[ ${this.instances.name} ]吗？这会导致该流程正在进行的任务不能正常执行，请谨慎处理。`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    let tempLoading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    await suspendProcessInstance(this.instances.id);// 暂停流程
                    tempLoading.close();
                    this.$emit('reloadProcess');
                }).catch(() => {
                });
            },
            async handelShowDiagram () {
                await this.setProcessViewInfo();
                this.isShowDiagram = true;
                setTimeout(() => {
                    // 调用子组件的方法
                    this.$refs.diagrams.setProcessState(this.isFinish);
                    this.$refs.diagrams.resetDiagramUrl();
                }, 0);
            },
            handelShowForms () {
                // console.log(this.instances);
                this.processInfo.serviceName = this.instances.processServiceName;
                this.processInfo.instanceName = this.instances.name;
                this.processInfo.processInstanceId = this.instances.id;
                this.processInfo.deploymentId = this.instances.deploymentId;
                this.isShowForms = true;
            },
            handelHideForms () {
                this.isShowForms = false;
            },
            async handleViewComment () {
                await this.getCommentList();
                // console.log(this.commentList);
                if (this.active !== true) {
                    this.active = true;
                }
            },
            hideSidebox () {
                this.active = false;
            },
            async dataImport () {
                // const param = {};
                // param.modelId = this.selectedModel.id;
                // setTimeout(() => { // 调用子组件的方法
                //     this.$refs.fileInstance.initParam(param);
                // }, 0);
                this.isShowUpload = true;
            },
            handleDownload (fileobj) {
                // this.fileDownloadUrl = `${API_FILE_DOWNLOAD}${fileobj.filePath}`;
                let url = `${API_FILE_DOWNLOAD}${fileobj.filePath}`;
                this.download(url);
            },
            download (url) {
                // var iframe = document.createElement('iframe');
                // iframe.style.display = 'none';
                // iframe.src = url;
                // document.body.appendChild(iframe);
                downloadFiles(url);
            },
            handleFileDelete (fileobj) {
                let param = {
                    processInstanceId: this.instances.id,
                    taskInstanceId: fileobj.taskId ? fileobj.taskId : null,
                    fileId: fileobj.id
                };
                this.$confirm(`您确定要删除文件[ ${fileobj.fileName} ]吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    if (fileobj.taskId) {
                        await delTaskFile(param);
                    } else {
                        await delProcessFile(param);
                    }
                    this.handleFileSearch();
                }).catch(() => {});
            },
            async handelProcessDetail (isReloadProcess) {
                this.isShowSetting = false;
                this.loadTimer = new Date().getTime();
                await this.setProcessViewInfo();
                this.isShowSetting = true;
                this.isReloadProcess = isReloadProcess;
            },
            async setProcessViewInfo () {
                //  console.log(this.instances);
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let tasks = await getAllUserTask(this.instances.id, this.instances.processServiceId, null, this.instances.deploymentId);
                // console.log(tasks);
                this.taskList = tasks;
                let treeList = [];
                if (this.instances.archiveTemplateId) {
                    treeList = await getArchiveTemplateTreeList({templateId: this.instances.archiveTemplateId});
                }
                this.archiveTemplateTreeList = treeList;
                loading.close();
            },
            async handelViewSubprocess (subProcessInstanceId) {
                await this.setSubProcessViewInfo(subProcessInstanceId);
                this.isShowSubDiagram = true;
                setTimeout(() => {
                    // 调用子组件的方法
                    this.$refs.subDiagrams.setProcessState(this.isFinish);
                    this.$refs.subDiagrams.resetDiagramUrl();
                }, 0);
            },
            async setSubProcessViewInfo (subProcessInstanceId) {
                // console.log(subProcessInstanceId);
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.subInstances = await getProcessInstancesDetail(subProcessInstanceId);
                // console.log(this.subInstances);
                let tasks = await getAllUserTask(this.subInstances.id, this.subInstances.processServiceId, null, this.subInstances.deploymentId);
                // console.log(tasks);
                this.subTaskList = tasks;
                let treeList = [];
                if (this.subInstances.archiveTemplateId) {
                    treeList = await getArchiveTemplateTreeList({templateId: this.subInstances.archiveTemplateId});
                }
                this.subArchiveTemplateTreeList = treeList;
                loading.close();
            },
            cancelProcessSetting () {
                if (this.isReloadProcess) {
                    this.$emit('reloadProcess', this.instances.id);
                }
                this.isShowSetting = false;
            },
            closeProcessSetting () {
                if (!this.isCancel) {
                    if (this.isReloadProcess) {
                        this.$emit('reloadProcess', this.instances.id);
                    }
                    this.isShowSetting = false;
                }
            },
            handleTabClick (tab, event) {
                this.isShowSaveBtn = false;
                // console.log(this.forms);
                if (tab.name === 'first') {
                    this.getRecordList();
                } if (tab.name === 'four') {
                    this.isShowArchiveTemplate = false;
                    this.isShowArchiveTable = true;
                    setTimeout(() => { // 默认回显值
                        this.$refs.archiveTable._initPage();
                    }, 0);
                } else if (tab.name === 'fifth' && this.forms.length > 0) {
                    this.isShowSaveBtn = true;
                } else if (tab.name === 'second') {
                    // this.loadTimerFile = new Date().getTime();
                    this.isShowMyFile = true;
                    // setTimeout(() => { // 默认回显值
                    //     this.$refs.processFiles._initPage();
                    // }, 0);
                } else if (tab.name === 'seventh') {
                    this.initTimeConig();
                } else if (tab.name === 'sixth') {
                    this.loadTimer = new Date().getTime();
                    this.isShowMyApproval = true;
                } else if (tab.name === 'third') {
                    this.isShowMyComment = true;
                    this.getCommentList();
                } else if (tab.name === 'eighth') {
                    this.initProcessAdjListPage();
                } else if (tab.name === 'ninth') {
                    this.initCloseConig();
                }
            },
            initTimeConig () {
                this.loadTimer = new Date().getTime();
                let timeConfigObj = {
                    id: this.instances.timeTemplateId,
                    processInstanceId: this.instances.id
                };
                setTimeout(() => {
                    this.$refs.timeConfigDetail._initPage(timeConfigObj);
                }, 0);
                this.isShowTimeConfigDetail = true;
            },
            async initCloseConig () {
                this.loadTimer = new Date().getTime();
                let closeTemplateObj = await getProcessInstanceCloseTemplate(this.instances.id, this.instances.closeTemplateId);
                setTimeout(() => {
                    this.$refs.closeTemplateDetailRef._initPage(closeTemplateObj);
                }, 0);
                this.isShowCloseConfigDetail = true;
            },
            async handelSaveForms () {
                let isNotValid = false;
                for (let i = 0, len = this.forms.length; i < len; i++) {
                    this.$refs['customForm' + i][0].validate((valid) => {
                        if (!valid) {
                            isNotValid = true;
                            return false;
                        }
                    });
                }
                if (!isNotValid) {
                    let process = {
                        processInstanceId: this.instances.id,
                        processServiceId: this.instances.processServiceId,
                        deploymentId: this.instances.processDefinitionDeploymentId,
                        forms: this.formData
                    };
                    // console.log(process);
                    const loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    await saveProcessInstance(process);
                    loading.close();
                }
            },
            handleFullScreen () {
                setTimeout(() => { // 默认回显值
                    this.$refs.archiveTable._initPage();
                }, 0);
                this.isFullScreen = true;
                this.isShowFullArchiveTable = true;
            },
            hideDialog () {
                this.isFullScreen = false;
            },
            async handleNavTask (record) {
                // console.log(record);
                if (record.taskInstanceId && record.recordType === 1) { // recordType;// 0事件 1任务 2网关 3子流程 4嵌套子流程......
                    // 1.判断当前任务的任务负责人是否是人当前登录人
                    // 2.是的话判断任务是否进行中，进行中则跳转到我的任务列表，不是的话就弹出任务详情
                    let currentUserStr = sessionStorage.getItem('currentUserInfo');
                    let currentUserInfo = JSON.parse(currentUserStr);
                    // console.log(currentUserInfo);
                    if (this.isShowNewMode || currentUserInfo.switchLayoutFlg === 2) { // 新版页面过的，任务跳转到新版
                        if (record.assigneeId !== undefined && record.assigneeId !== '' && record.assigneeId === currentUserInfo.userId) {
                            // 跳转到任务，并打开详情
                            let taskInfo = await getProcessTaskDetail(record.taskInstanceId);
                            let processTaskStr = {};
                            processTaskStr.processInstanceId = record.processInstanceId;
                            processTaskStr.processInstanceName = this.instances.name;
                            processTaskStr.taskInstanceId = record.taskInstanceId;
                            processTaskStr.taskName = record.taskName;
                            if (taskInfo) {
                                processTaskStr.taskState = taskInfo.taskState;
                            }
                            let processTaskJson = JSON.stringify(processTaskStr);
                            sessionStorage.setItem('navToTaskList', processTaskJson);
                            // 跳转页面
                            if (this.isFromBusTab) { // 来源于新版的应用tab
                                this.$emit('navToBusiniessTaskTab');
                            } else {
                                this.navMyTaskMyAssignee();// 我负责
                            }
                        } else {
                            // 流程发起人、负责人、抄送人可查看任务详情
                            let isCopyUser = false;
                            if (this.instances.copyUserList && this.instances.copyUserList.length > 0) {
                                // 当前登录人是否是抄送人
                                for (let item of this.instances.copyUserList) {
                                    if (currentUserInfo.userId === item.copyUserId) {
                                        isCopyUser = true;
                                    }
                                }
                            }
                            let isViewTaskAuth = this.viewTaskAuth();
                            if (currentUserInfo.userId === this.instances.startedBy.id ||
                            (this.instances.assigneeUserId !== undefined && this.instances.assigneeUserId !== '' && this.instances.assigneeUserId === currentUserInfo.userId) ||
                            isCopyUser || isViewTaskAuth) {
                                this.showTaskDetailDialog(record);
                            } else {
                                this.$message({message: '此处只能快速跳转自己负责的任务', type: 'warning'});
                            }
                        }
                    } else {
                        if (record.assigneeId !== undefined && record.assigneeId !== '' && record.taskState === 0 && record.assigneeId === currentUserInfo.userId) { // taskState;//任务状态 0进行中 1已完成
                            sessionStorage.setItem('paramTaskInstanceId', record.taskInstanceId);
                            // this.navigateTo('/process/myProcess/' + this.taskInfo.processInstanceId);
                            this.navMyTask();
                        } else {
                            // 流程发起人、负责人、抄送人可查看任务详情
                            let isCopyUser = false;
                            if (this.instances.copyUserList && this.instances.copyUserList.length > 0) {
                                // 当前登录人是否是抄送人
                                for (let item of this.instances.copyUserList) {
                                    if (currentUserInfo.userId === item.copyUserId) {
                                        isCopyUser = true;
                                    }
                                }
                            }
                            let isViewTaskAuth = this.viewTaskAuth();
                            if (this.ifConfigTask || this.ifConfigProcess || currentUserInfo.userId === this.instances.startedBy.id ||
                            (this.instances.assigneeUserId !== undefined && this.instances.assigneeUserId !== '' && this.instances.assigneeUserId === currentUserInfo.userId) ||
                            isCopyUser || isViewTaskAuth) {
                                this.showTaskDetailDialog(record);
                            } else {
                                this.$message({message: '此处只能快速跳转自己负责的任务', type: 'warning'});
                            }
                        }
                    }
                }
            },
            viewTaskAuth () {
                let isEditAuth = false;
                let currentUserStr = sessionStorage.getItem('currentUserInfo');
                if (currentUserStr) {
                    let currentUserInfo = JSON.parse(currentUserStr);
                    let resources = currentUserInfo.resources;
                    if (resources) {
                        for (let i = 0; i < resources.length; i++) {
                            if (resources[i].resourceUrl === 'AllProcessInstanceData') { // 是否可以查看所有流程(同时也包括查看非自己负责的所有任务)
                                isEditAuth = true;
                                break;
                            }
                        }
                    }
                }
                return isEditAuth;
            },
            async showTaskDetailDialog (record) {
                this.isShowTaskDetail = false;
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.taskInfo = await getProcessTaskDetail(record.taskInstanceId);
                // setTimeout(() => {
                //     this.$refs.taskDetailRef._initFormData();
                // }, 0);
                loading.close();
                this.isShowTaskDetail = true;
            },
            async changeSwitch () {
                await this.getRecordList();
            },
            handlePrint (index) {
                this.loadTimer = new Date().getTime();
                // this.$print(this.$refs['customForm' + index]);
                // this.$print(this.$refs.customForm0);
                this.printForm = this.formData[index];
                this.printForm.fieldsList = this.forms[index].fieldsList;
                this.printForm.formName = this.forms[index].formName;
                // console.log(this.printForm);
                this.isShowPrintUtil = true;
            },
            async handelProcessTemplate () { // 流程模板干预
                this.oldProcessInstanceName = '';
                await this.setTemplateInfo();
                // this.resetShowStatus(process);
                this.isShowTemplateDesc = true;
                setTimeout(() => { // 默认回显值
                    this.$refs.templatePop._initPage(this.templateInfo);
                }, 0);
            },
            async setTemplateInfo () {
                this.templateInfo.processInstanceId = this.instances.id;
                this.templateInfo.processInstanceName = this.instances.name;
                this.templateInfo.id = this.instances.templateId;
                this.templateInfo.processServiceType = this.instances.processServiceType;
                this.templateInfo.processServiceTypeName = this.instances.processServiceTypeName;
                this.templateInfo.processServiceId = this.instances.processServiceId;
                this.templateInfo.deploymentId = this.instances.deploymentId;
                this.templateInfo.templateName = this.instances.templateName;
                this.templateInfo.templateDesc = this.instances.templateDesc;
                this.templateInfo.archiveTemplateId = this.instances.archiveTemplateId;
                this.templateInfo.timeTemplateId = this.instances.timeTemplateId;
                this.templateInfo.closeTemplateId = this.instances.closeTemplateId;
                // this.templateInfo.timeTemplateName = this.instances.timeTemplateId;
                let template = await getProcessInstanceTemplate(this.instances.id, this.instances.processServiceId, this.instances.deploymentId);
                this.templateInfo.dataOperate = template.dataOperate;
                this.templateInfo.claimMode = template.claimMode;
                this.templateInfo.completeFirstTask = template.completeFirstTask;
                this.templateInfo.processViewPanes = template.processViewPanes;
                this.templateInfo.taskViewPanes = template.taskViewPanes;
                this.templateInfo.processExtJson = template.processExtJson;
                this.templateInfo.planTimeMode = template.planTimeMode;
                this.templateInfo.autoCompleteTask = template.autoCompleteTask;
                this.templateInfo.canViewAllFile = template.canViewAllFile;
                this.templateInfo.parentProcessInstanceId = template.parentProcessInstanceId;
                this.templateInfo.parentProcessInstanceName = template.parentProcessInstanceName;
                this.templateInfo.parentTaskInstanceId = template.parentTaskInstanceId;
                this.templateInfo.reports = template.reports;
                this.templateInfo.parentProcessInstanceMode = template.parentProcessInstanceMode;
                this.templateInfo.processTaskAssignerMode = template.processTaskAssignerMode;
                this.oldProcessInstanceName = this.instances.name;
            },
            async handleEditTemplateInfo () {
                if (this.templateInfo.processInstanceName.trim() === '') {
                    this.$message({message: '请输入流程名称', type: 'warning'});
                    return;
                }
                await saveProcessInstanceTemplate(this.templateInfo);// 修改流程实例模板信息(流程表单和档案模板)
                this.$emit('reloadProcess', this.instances.id, this.oldProcessInstanceName !== this.templateInfo.processInstanceName.trim());
                this.isShowTemplateDesc = false;
            },
            handleFullScreenForApproval () {
                this.isFullScreenForApproval = true;
                this.isShowFullScreenForApproval = true;
            },
            hideFullScreenDialogForApproval () {
                this.isFullScreenForApproval = false;
                this.$refs.myApproval.handleRefrenshApprovalList();
            },
            handleFullScreenForTime () {
                this.initTimeConig();
                this.isShowFullScreenForTime = true;
                this.isFullScreenForTime = true;
            },
            hideFullScreenDialogForTime () {
                this.initTimeConig();
                this.isFullScreenForTime = false;
                this.isShowFullScreenForTime = false;
            },
            initProcessAdjListPage () {
                this.currentProcessInstanceId = this.instances.id;
                // console.log("当前流程实例ID"+this.currentProcessInstanceId);
                setTimeout(() => {
                    // 调用子组件的方法
                    this.$refs.processAdjList._initPage();
                }, 0);
            },
            async handleProcessFormFullScreen (instance, form) {
                this.formInfo.formObj = {};
                this.formInfo.formObj.instance = JSON.stringify(instance);
                this.formInfo.formObj.structure = [];
                this.formInfo.formObj.structure[0] = form;
                this.formInfo.modelName = form.modelName;
                this.formInfo.appName = form.appName;
                // this.formInfo.modelName = this.formInfo.formObj.structure[0].modelName;
                // this.formInfo.appName = this.formInfo.formObj.structure[0].appName;
                // this.formInfo.remarks = this.selectedModel.remarks;
                // this.formInfo.modelType = this.selectedModel.modelType;
                this.processLoadTimer = new Date().getTime();
                this.isShowModelDetail = true;
                this.setIsShowForm(false);
                setTimeout(() => {
                    this.$refs.modelDetailChild.loadFormData(this.formInfo, {isShowEdit: true}, {isCanEdit: true}, false);
                }, 0);
            },
            setIsShowForm (status) {
                this.isShowFormDetail = status;
            },
            async handleModelComplete (obj) {
                // console.log(obj);
                this.formData.forEach(form => {
                    if (form.formId === obj.forms[0].formId && obj.forms[0].values) {
                        form.values = obj.forms[0].values;
                    }
                });
                this.loadTimerList = new Date().getTime();
                // this.$emit('taskTemporarySave', { btnConditions: this.btnConditions, forms: this.formData, modelInstanceIds: this.modelInstanceIds });
                this.isShowModelDetail = false;
                await this.handelSaveForms();
            },
            handleModeSwich () {
                this.$emit('handleModeSwich', 'list');
            },
            changeLeftTree (isCollapse) {
                this.$emit('setShowleftList', isCollapse);
            },
            handelProcessAssigneeUser () {
                this.loadTimer = new Date().getTime();
                setTimeout(() => { // 初始化
                    this.$refs.userOrg._initPage();
                }, 0);
                this.isShowUserOrg = true;
            },
            async confirmClick () {
                this.$refs.userOrg.setChoosedUser();
                // console.log(this.selectedUser.selectedUserIds);
                if (isEmpty(this.selectedUser.selectedUserIds)) {
                    this.$message({message: '流程负责人不能为空', type: 'warning'});
                } else {
                    await updProcessAssigneeUser({processInstanceId: this.instances.id, assigneeUserId: this.selectedUser.selectedUserIds});
                    this.isShowUserOrg = false;
                    if (this.isShowNewMode) {
                        this.$emit('reloadProcess', this.instances.id);
                    } else {
                        this.$emit('refreshProcessInfo', this.instances);
                    }
                }
            },
            async handelProcessCopyUser () {
                this.loadTimer = new Date().getTime();
                this.selectedCopyUser = {
                    selectedUserIds: '',
                    selectedUserNames: ''
                };
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let copyUsers = await getProcessInstanceCopyUserList({processInstanceId: this.instances.id});
                // console.log(copyUsers);
                if (!isEmpty(copyUsers) && copyUsers.length > 0) {
                    copyUsers.forEach(row => {
                        if (row) {
                            if (isEmpty(this.selectedCopyUser.selectedUserIds)) {
                                this.selectedCopyUser.selectedUserIds = row.copyUserId;
                                this.selectedCopyUser.selectedUserNames = row.copyUserName;
                            } else {
                                this.selectedCopyUser.selectedUserIds = this.selectedCopyUser.selectedUserIds + ',' + row.copyUserId;
                                this.selectedCopyUser.selectedUserNames = this.selectedCopyUser.selectedUserNames + ',' + row.copyUserName;
                            }
                        }
                    });
                } else {
                    this.selectedCopyUser.selectedUserIds = '';
                }
                loading.close();
                setTimeout(() => { // 初始化
                    this.$refs.copyUserOrg._initPage();
                }, 0);
                this.isShowCopyUserOrg = true;
            },
            async confirmCopyUserClick () {
                this.$refs.copyUserOrg.setChoosedUser();
                // console.log(this.selectedUser.selectedUserIds);
                await saveProcessInstanceCopyUsers({processInstanceId: this.instances.id, copyUserIds: this.selectedCopyUser.selectedUserIds, copyUserNames: this.selectedCopyUser.selectedUserNames});
                this.isShowCopyUserOrg = false;
            },
            // async handleParentProcess () {
            //    // sessionStorage.setItem('paramProcessInstanceId', '780298');
            //    // // this.navMyProcess();
            //    // this.$emit('reloadProcess');
            //    this.instancesInfo = await getProcessInstancesDetail('780298');
            //    this.isCancel = false;
            //    this.loadTimer = new Date().getTime();
            //    this.isShowProcessDetail = true;
            // },
            async handelShowProcessRelate () {
                this.loadTimer = new Date().getTime();
                setTimeout(() => {
                    this.$refs.processRelateTree._initPage();
                }, 0);
                this.isShowProcessRelate = true;
            },
            async handelShowReportRelateTree () {
                this.loadTimer = new Date().getTime();
                setTimeout(() => {
                    this.$refs.reportRelateTree._initPage();
                }, 0);
                this.isShowReportRelateTree = true;
            },
            loadLinkData (data, targetField) {
                for (let index = 0, len = this.forms.length; index < len; index++) {
                    if (this.forms[index].fieldsList && this.forms[index].fieldsList.length > 0) {
                        for (var i = 0; i < this.forms[index].fieldsList.length; i++) {
                            let tempField = this.forms[index].fieldsList[i];
                            if (targetField.id === tempField.id) {
                                this.$refs['fieldItemChild' + i][0].initAddLinkData(data);
                            }
                        }
                    }
                }
            },
            refreshViewField () {
                // console.log(this.formData[0].values);
                this.loadTimerField = new Date().getTime();
            },
            navToBusiniessTaskTab () {
                this.$emit('navToBusiniessTaskTab');
            },
            asynMainFormData (sourceData, selectTableColumns, currentlinkFieldId, index) {
                // console.log(index);
                if (selectTableColumns && Array.isArray(selectTableColumns)) {
                    let targetFormFieldlist = this.forms[index].fieldsList;
                    selectTableColumns.forEach(fieldObj => {
                        let sourceFieldLabel = fieldObj.label;
                        targetFormFieldlist.forEach(element => {
                            // console.log('关联配置的关联字段ID:' + element.options.synLinkField);
                            if (element.options.synLinkField && element.options.synLinkField === currentlinkFieldId) {
                                if (element.options.synLinkFormFieldId) {
                                    if (element.options.synLinkFormFieldId === fieldObj.id) {
                                        this.updSynLinkFieldData(element, fieldObj, sourceData, index);
                                    }
                                } else {
                                    if (sourceFieldLabel === element.name && element.type === 'text') {
                                        this.updSynLinkFieldData(element, fieldObj, sourceData, index);
                                    }
                                }
                            }
                        });
                    });
                    selectTableColumns.forEach(fieldObj => {
                        if (fieldObj.type === 'subform') {
                            // console.log(fieldObj);
                            // console.log(currentlinkFieldId);// 当前表单的关联字段id
                            targetFormFieldlist.forEach(element => {
                                // console.log('关联配置的关联字段ID:' + element.options.synLinkField);
                                if (element.options.dataSourceFieldId && element.options.dataSourceFieldId === currentlinkFieldId) {
                                    if (element.options.dataSourceSubFieldId) {
                                        if (element.options.dataSourceSubFieldId === fieldObj.id) {
                                            if (this.forms[index].fieldsList && this.forms[index].fieldsList.length > 0) {
                                                for (let i = 0; i < this.forms[index].fieldsList.length; i++) {
                                                    let tempField = this.forms[index].fieldsList[i];
                                                    if (element.id === tempField.id) {
                                                        this.$refs['fieldItemChild' + i][0].reSetSelectOptions(element, fieldObj, sourceData);
                                                    }
                                                }
                                            }
                                            // this.reSetSelectOptions(element, fieldObj, sourceData, index);
                                        }
                                    }
                                }
                            });
                        }
                    });
                }
            },
            // 修改配置了关联映射的字段值
            updSynLinkFieldData (element, fieldObj, sourceData, index) {
                // console.log(element);
                let type = fieldObj.type;
                let sourceValue = ''; // 级联显示从源数据中拉出来的字段值
                let can = false; // 是否支持级联显示
                if (type === 'dictionary' || type === 'businessTree' || type === 'department') {
                    // -tree
                    can = true;
                    sourceValue = sourceData[fieldObj.id + '-tree'];
                } else if (type === 'user') {
                    // -user
                    can = true;
                    sourceValue = sourceData[fieldObj.id + '-user'];
                } else if (type === 'category' || type === 'select' || type === 'file' || type === 'process' || type === 'address' || type === 'cascader' || type === 'role') {
                    // -view
                    can = true;
                    sourceValue = sourceData[fieldObj.id + '-view'];
                } else if (type === 'calculation' || type === 'subFormSummary' || type === 'number' || type === 'text' || type === 'serialNumber' || type === 'date') {
                    can = true;
                    sourceValue = sourceData[fieldObj.id];
                } else if (type === 'link') {
                    can = true;
                    sourceValue = sourceData[fieldObj.id + '-view'];
                } else if (type === 'subform') {
                    can = true;
                    sourceValue = sourceData[fieldObj.id];
                }
                if (can) {
                    if (element.type === 'text') {
                        this.formData[index].values[element.id] = sourceValue;
                        this.formData[index].values[element.id + '-view'] = '';
                    } else if (element.type === 'number' || element.type === 'calculation') {
                        if (!isEmpty(sourceValue)) {
                            this.formData[index].values[element.id] = sourceValue;
                            this.formData[index].values[element.id + '-view'] = '';
                        } else {
                            this.formData[index].values[element.id] = '';
                            this.formData[index].values[element.id + '-view'] = '';
                        }
                        this.refreshViewField();
                    } else if (element.type === 'select') {
                        // console.log(element);
                        if (!isEmpty(sourceValue)) {
                            // 下拉选项值
                            let targetFieldValue = {};
                            let targetFieldOptions = element.options.config.options;
                            for (let i = 0; i < targetFieldOptions.length; i++) {
                                let optionItem = targetFieldOptions[i];
                                if (optionItem.title === sourceValue) {
                                    targetFieldValue = optionItem;
                                    break;
                                }
                            }
                            if (targetFieldValue) {
                                this.formData[index].values[element.id] = targetFieldValue.value;
                                this.formData[index].values[element.id + '-view'] = targetFieldValue.title;
                            }
                        } else {
                            this.formData[index].values[element.id] = '';
                            this.formData[index].values[element.id + '-view'] = '';
                        }
                    } else if (element.type === 'subform') {
                        let sourceSubColumns = fieldObj.subColumns;
                        if (isEmpty(sourceSubColumns)) { // 智能关联，需要这样取值
                            sourceSubColumns = fieldObj.options.fieldList;
                            for (let k = 0; k < sourceSubColumns.length; k++) {
                                sourceSubColumns[k].label = sourceSubColumns[k].name;
                            }
                        }
                        let taragetSubColumns = element.options.fieldList;
                        let newValue = [];
                        // console.log(sourceSubColumns);
                        // console.log(taragetSubColumns);
                        // console.log(element);
                        // console.log(sourceValue);
                        if (!isEmpty(sourceValue)) {
                            for (let i = 0; i < sourceValue.length; i++) {
                                let sourceItemValue = sourceValue[i];
                                let targetItemValue = {};
                                // console.log(sourceItemValue);
                                for (let j = 0; j < taragetSubColumns.length; j++) { // 寻找同名的字段，然后获取其值付给目标字段
                                    let targetColumn = taragetSubColumns[j];
                                    for (let k = 0; k < sourceSubColumns.length; k++) {
                                        let sourceColumn = sourceSubColumns[k];
                                        if (targetColumn.label === sourceColumn.label) {
                                            if (sourceColumn.type === 'dictionary' || sourceColumn.type === 'businessTree' || sourceColumn.type === 'department') {
                                                // -tree
                                                targetItemValue[targetColumn.id] = sourceItemValue[sourceColumn.id + '-tree'];
                                            } else if (sourceColumn.type === 'user') {
                                                // -user
                                                targetItemValue[targetColumn.id] = sourceItemValue[sourceColumn.id + '-user'];
                                            } else if (sourceColumn.type === 'category' || sourceColumn.type === 'select' || sourceColumn.type === 'file' || sourceColumn.type === 'process' || sourceColumn.type === 'address' || sourceColumn.type === 'cascader' || sourceColumn.type === 'role') {
                                                // -view
                                                targetItemValue[targetColumn.id] = sourceItemValue[sourceColumn.id + '-view'];
                                            } else if (sourceColumn.type === 'calculation' || sourceColumn.type === 'number' || sourceColumn.type === 'text' || sourceColumn.type === 'serialNumber' || sourceColumn.type === 'date') {
                                                targetItemValue[targetColumn.id] = sourceItemValue[sourceColumn.id];
                                            }
                                            break;
                                        }
                                    }
                                }
                                if (!isEmpty(targetItemValue)) {
                                    newValue.push(targetItemValue);
                                }
                            }
                            // console.log(newValue);
                            this.formData[index].values[element.id] = newValue;
                        } else {
                            this.formData[index].values[element.id] = '';
                        }
                    }
                }
            },
            async handleApprovalDetail (record) {
                this.approvalDetail = {};
                if (record.approvalInstanceId) {
                    this.approvalDetail = await getApprovalInstanceDetail(record.approvalInstanceId);
                    this.isShowDynamicApprovalPop = true;
                }
            },
            activeClass (item) {
                // 1审批中 2通过 3驳回
                if (item.approvalStatus === 1) {
                    return 'doing';
                } else if (item.approvalStatus === 2) {
                    return 'success';
                } else if (item.approvalStatus === 3) {
                    return 'reject';
                } else if (item.approvalStatus === 4) {
                    return 'terminal';
                } else {
                    return '';
                }
            },
            async jumpTaskProcessInstances () {
                let param = {processInstanceId: this.instances.id};
                console.log(param);
                let res = jumpTaskProcessInstances(param);
                console.log(res);
            }
            // reSetSelectOptions (element, fieldObj, sourceData, index) {
            //     let type = fieldObj.type;
            //     let sourceValue = ''; // 级联显示从源数据中拉出来的字段值
            //     if (type === 'subform') {
            //         sourceValue = sourceData[fieldObj.id];
            //         if (element.type === 'select') {
            //             let sourceSubColumns = fieldObj.subColumns;
            //             if (isEmpty(sourceSubColumns)) { // 智能关联，需要这样取值
            //                 sourceSubColumns = fieldObj.options.fieldList;
            //                 for (let k = 0; k < sourceSubColumns.length; k++) {
            //                     sourceSubColumns[k].label = sourceSubColumns[k].name;
            //                 }
            //             }
            //             let newOptions = [];
            //             // console.log(sourceSubColumns);
            //             // console.log(taragetSubColumns);
            //             // console.log(element);
            //             // console.log(sourceValue);
            //             if (!isEmpty(sourceValue)) {
            //                 for (let i = 0; i < sourceValue.length; i++) {
            //                     let sourceItemValue = sourceValue[i];
            //                     let targetItemValue = {
            //                         id: '',
            //                         title: '',
            //                         value: '',
            //                         def: false,
            //                         optionConfigId: element.options.config.id,
            //                         formId: element.formId
            //                     };
            //                     // console.log(sourceItemValue);
            //                     for (let k = 0; k < sourceSubColumns.length; k++) {
            //                         let sourceColumn = sourceSubColumns[k];
            //                         if (element.name === sourceColumn.label) {
            //                             if (sourceColumn.type === 'dictionary' || sourceColumn.type === 'businessTree' || sourceColumn.type === 'department') {
            //                                 // -tree
            //                                 targetItemValue.title = sourceItemValue[sourceColumn.id + '-tree'];
            //                                 targetItemValue.label = sourceItemValue[sourceColumn.id + '-tree'];
            //                                 targetItemValue.value = sourceItemValue[sourceColumn.id + '-tree'];
            //                             } else if (sourceColumn.type === 'user') {
            //                                 // -user
            //                                 targetItemValue.title = sourceItemValue[sourceColumn.id + '-user'];
            //                                 targetItemValue.label = sourceItemValue[sourceColumn.id + '-user'];
            //                                 targetItemValue.value = sourceItemValue[sourceColumn.id + '-user'];
            //                             } else if (sourceColumn.type === 'category' || sourceColumn.type === 'select' || sourceColumn.type === 'file' || sourceColumn.type === 'process' || sourceColumn.type === 'address' || sourceColumn.type === 'cascader' || sourceColumn.type === 'role') {
            //                                 // -view
            //                                 targetItemValue.title = sourceItemValue[sourceColumn.id + '-view'];
            //                                 targetItemValue.label = sourceItemValue[sourceColumn.id + '-view'];
            //                                 targetItemValue.value = sourceItemValue[sourceColumn.id + '-view'];
            //                             } else if (sourceColumn.type === 'calculation' || sourceColumn.type === 'number' || sourceColumn.type === 'text' || sourceColumn.type === 'serialNumber' || sourceColumn.type === 'date') {
            //                                 targetItemValue.title = sourceItemValue[sourceColumn.id];
            //                                 targetItemValue.label = sourceItemValue[sourceColumn.id];
            //                                 targetItemValue.value = sourceItemValue[sourceColumn.id];
            //                             }
            //                             break;
            //                         }
            //                     }
            //                     if (!isEmpty(targetItemValue)) {
            //                         newOptions.push(targetItemValue);
            //                     }
            //                 }
            //             }
            //             // console.log(newOptions);
            //             // 重置选项list
            //             // let formInfo = this.formInfo.formObj.structure[0];
            //             // if (formInfo.fieldsList && formInfo.fieldsList.length > 0) {
            //             //     for (var i = 0; i < formInfo.fieldsList.length; i++) {
            //             //         let tempField = formInfo.fieldsList[i];
            //             //         if (element.id === tempField.id) {
            //             //             this.$refs['fieldItemChild' + i][0].resetSelectFieldOptions(newOptions);
            //             //         }
            //             //     }
            //             // }
            //             if (this.forms[index].fieldsList && this.forms[index].fieldsList.length > 0) {
            //                 for (var i = 0; i < this.forms[index].fieldsList.length; i++) {
            //                     let tempField = this.forms[index].fieldsList[i];
            //                     if (element.id === tempField.id) {
            //                         this.$refs['fieldItemChild' + i][0].resetSelectFieldOptions(newOptions);
            //                     }
            //                 }
            //             }
            //         }
            //     }
            // }
        }
    };
</script>

<style lang="less">
    .process-report-dialog {
        width: 800px;
        min-width: 600px;
        .el-dialog__body{
            height: ~"calc(100% - 14vh)";
            .process-report-list{
                height: 100%;
                .business-report-tree-card{
                    height: 100%;
                    .el-tabs__content{
                        height: ~"calc(100% - 14vh)";
                        overflow: auto;
                        .el-tab-pane{
                            height: ~"calc(100% - 5vh)";
                        }
                    }
                }
            }
        }
        // max-width: 1200px;
    }
    .instances-detail {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        flex: 1;
        display: flex;
        flex-direction: column;

        .instances-head{
          width: 55%;
        }
        .instances-desc {
            // margin: 15px 15px;
            // margin: 15px 6px 15px 0px;
            margin: 15px 6px -5px 0px;
            .el-card__body {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }
        }

        .desc-content2 {
            margin: 5px 0 0 0;
            & > span {
                margin: 0 10px 0 0;
            }
        }

        .instances-content {
            height: ~"calc(100% - 60px)";
            overflow: auto;
            flex: 1;
            // padding: 0 15px;
            margin-top: -10px;
            display: flex;
            flex-direction: row;

            .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
              margin-bottom:2px
            }

            .content-instanceRecord{
              margin-top: -12px;
              .el-card__header{
                padding: 8px 20px;
              }
            }
        }

       .content-left {
            width: 35%;
            margin: 0 5px;
            overflow-y: auto;
        }
       .content-form-left {
            width: 100%;
            margin: 0 5px;
            overflow-y: auto;
        }
        // .content-center {
        //      width: 35%;
        //      margin: 0 5px;
        //      overflow-y: auto;
        // }
        .content-right {
             width: 65%;
             margin: 0 5px;
             overflow-y: auto;
        }
        .sideboxcls {
            width: 30%;
            // height: 30%;
            overflow-y: auto;
        }
        .comments {
            width: 100%;
            height: 100%;
            overflow-y: auto;
        }
        .record-list {
            margin-top: -12px;
            width: 100%;
            // height: 100%;
            height: 400px;
            overflow-y: auto;
            // width: 350px;
        }
        .record-item {
            font-size: 12px;
            height: 70px;

            display: flex;
            flex-direction: column;
        }
        .record-item:last-child{
            .record-content4{
                .record-line{
                   & > span{
                       background: none;
                       width: 2px;
                       height: 100%;
                   };
                }
            }
        }
        .record-content1 {
            font-weight: 700;
            font-size: 16px;
            display: flex;
            flex-direction: row;
        }
        .record-content2 {
            color: #8bc34a;
        }
        .record-content5 {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #4ac3a1;
        }
        .record-content6 {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color:#409eff;
        }
        .record-content3 {
            color: #adadad;
        }
        .record-content4 {
            flex: 1;
            display: flex;
            flex-direction: row;
            justify-items: center;
        }
        .record-icon {
            font-size: 14px;
            width: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .record-line {
            & > span {
                background: #ebeef5;
                width: 2px;
                height: 100%;
            }
        }
        .record-opinion{
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;// 限制快级元素的文本行数
          overflow: hidden;
          font-size:12px;
          font-weight:500;
        }

        .diagram-dialog {
            // height: 650px;
            // height: 80%;
        }
        .el-collapse-title {
          // color: #409eff;
          color: #4ebe17;
          // font-size: 18px;
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: space-between;
          & > .el-button {
              margin-right: 10px;
          }
        }
        .process-detail-Forms{
          .el-form-item__label{
            color: #333;
            font-weight: 700;
          }
        }
        .popDetailTaskClass{
          .el-dialog__body{
              padding: 0px 5px;
              color: #606266;
              font-size: 14px;
              word-break: break-all;
          }
        }
        .processTreeHead {
            color: rgb(3, 169, 244);
            margin-bottom: 10px;
            margin-top: -5px;
        }
        .approvalStatus{
            .success{
                color: #67c23a;
                border-color: #67c23a;
            }
            .reject{
                color: #f56c6c;
            }
            .doing{
                color: #409eff;
                border-color: #409eff; 
            } 
            .terminal{
                color: #E6A23C;
            }
        }
        
    }
</style>



// WEBPACK FOOTER //
// src/pages/process/MyProcess/ProcessDetail.vue